
import { AuthService } from "../services/auth-service";
import AppContainer from "@/components/login/LoginContainer.vue";
import AppSection from "@/components/login/LoginSection.vue";
import AppTitle from "@/components/login/LoginTitle.vue";
import AppText from "@/components/login/LoginText.vue";
import AppButton from "@/components/login/LoginButton.vue";
import { FormLike } from "winfakt-vue-components/src/mixins/form-like";

export default FormLike.extend({
	data(){
		return {
			password: "",
			repeatPassword: "",
			finished: false
		};
	},
	computed: {
		buttonDisabled():boolean {
			return !this.isValid;
		}
	},
	methods: {
		async submit(){
			if (!this.isValid) return;
			await AuthService.resetPassword(this.$route.params.token, this.password);
			this.finished = true;
		},
		isSameValidator(value:string):boolean | string {
			if (value != this.password){
				return "De wachtwoorden zijn niet hetzelfde";
			}
			return true;
		}
	},
	i18nEx: {
		componentPrefix: "views.ThePasswordReset"
	},
	components: {
		AppContainer,
		AppButton,
		AppSection,
		AppTitle,
		AppText
	},
	mounted(){
		let splashEl = document.getElementById("splash");
		if (!splashEl) return;
		splashEl.remove();
		this.validate();
	}
});
